module.exports = __webpack_public_path__ + "img/logo.7dfc11e0.png";